__webpack_require__.p = "/median-xl-runewords/";